import * as types from '../constants/actionTypes';

//import objectAssign from 'object-assign';
import initialState from './initialState';


export default function userReducer(state = initialState.user, action) {

  switch (action.type) {

    case types.GET_USER:
      return {
        logged_in: false,
        loading: true
      };

    case types.GET_USER_SUCCESS:
      return {
        logged_in: true,
        loading: false,
        ...action.data
      };

    case types.GET_USER_FAILURE:
      return {
        logged_in: false,
        loading: false
      };

    case types.UNAUTHORIZED: {
      return {
        loading: false,
        logged_in: false
      };
    }

    default:
      return state;

  }
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js